import React, { useState, useEffect } from 'react';
import { FaUser, FaClock, FaBrain, FaPlus, FaArrowLeft } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
import { APIURL } from "../../../Global";
import axios from "axios";
import './AssessmentHistory.css'; // Fixed import - added .css extension
import { useAlert } from 'react-alert';
import TiltTable from './TiltTable';
import DocumentPopup from './DocumentPopup';

const TiltDashboard = () => {
  const [recordings, setRecordings] = useState([]);
  const [selectedRecordings, setSelectedRecordings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState('');
  const alert = useAlert();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState({
    id: location?.state?.id || null,
    therapy_id: location?.state?.therapy_id || null,
    inpatient: location?.state?.inpatient || null,
    mob: location?.state?.mob || null,
    appt: location?.state?.appt || null
  });

  // Set session storage once on mount
  useEffect(() => {
    sessionStorage.setItem('previousPath', '/tilt');
  }, []);

  useEffect(() => {
    fetchRecordings();
  }, [userInfo.id]); // Added dependency

  useEffect(() => {
    if (userInfo.id) {
      patientInfo();
    }
  }, [userInfo.id]); // Added dependency and condition

  const fetchRecordings = async () => {
    if (!userInfo.id) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const tokenString = sessionStorage.getItem("usertoken");

      if (!tokenString) {
        alert.error('Authentication token not found');
        setLoading(false);
        return;
      }

      const token = tokenString.replace(/["]+/g, "");

      const response = await axios.get(
        `${APIURL}/api/v1/patient/therapy-scale/?recordings=tilt&patient_id=${userInfo.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      );

      if (response.data.status === 'success') {
        setRecordings(response.data.message.slice().reverse());
      } else {
        alert.error(response.data.message || 'Error occurred while fetching recordings');
      }
    } catch (err) {
      console.error('Error fetching recordings:', err);
      alert.error('Failed to fetch recordings. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const patientInfo = async () => {
    if (!userInfo.id) return;

    try {
      const tokenString = sessionStorage.getItem("usertoken");

      if (!tokenString) {
        console.error('Authentication token not found');
        return;
      }

      const token = tokenString.replace(/["]+/g, "");

      const response = await axios.get(
        `${APIURL}/api/v1/doctor/patient-dashboard/?patient_id=${userInfo.id}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );

      if (response.data.status === "success") {
        setUserInfo(prevUserInfo => ({
          ...prevUserInfo,
          name: response.data.data.name,
          age: response.data.data.age,
          gender: response.data.data.gender,
          photo: response.data.data.photo
        }));
      }
    } catch (error) {
      console.error('Error fetching patient info:', error);
    }
  };

  const handleAssessmentSelect = (recording) => {
    setShow('')
    setSelectedRecordings(recording);

  };

  const handleReassessmentClick = () => {
    setShow('tilt');
    setSelectedRecordings(null);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="spinner"></div>
          <p>Loading recordings...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="assessment-history">
      <div>
        <div className="header-section">
          <div className="header-left">
            <h1 className="page-title">
              Recordings History
            </h1>
          </div>
          <button
            className="new-assessment-btn"
            onClick={handleReassessmentClick}
            style={{
              backgroundColor: show === 'tilt' ? '#1d4fd8b5' : '',
              width: '15%'
            }}
            disabled={userInfo.appt}
          >
            <FaPlus className="btn-icon" />
            Tilt Table
          </button>
        </div>

        {/* Main Content Area */}
        <div className="main-content">
          <div className="history-view">
            <div className="assessment-list-section col-3">
              <div className="list-container">
                <div className="list-header">
                  <h2>Available Assessments</h2>
                  <p>{recordings.length} recordings found</p>
                </div>

                <div className="list-content">
                  {recordings.length === 0 ? (
                    <div className="empty-message">
                      Unable to load recordings or No recordings found
                    </div>
                  ) : (
                    recordings.map((recording, index) => (
                      <div
                        key={recording.id || index}
                        onClick={() => handleAssessmentSelect(recording)}
                        className={`assessment-item ${selectedRecordings?.id === recording.id ? 'selected' : ''
                          }`}
                      >
                        <div className="item-content">
                          <div className="item-details">
                            {recording.created_at && (
                              <p className="item-date">
                                {new Date(recording.created_at).toLocaleDateString()}
                              </p>
                            )}
                            {recording.description && (
                              <p className="item-description">
                                {recording.description}
                              </p>
                            )}
                          </div>
                          <div className="item-arrow">›</div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>

            {/* Dynamic Details Section */}
            <div className="assessment-details-section col-9">
              <div className="details-container">
                {show === 'tilt' ? (
                  <TiltTable
                    data={userInfo}
                    handleSuccess={fetchRecordings}
                    mode='create'
                  />
                ) : selectedRecordings ? (
                  <DocumentPopup
                    id={userInfo.id}
                    type='tilt'
                    document={selectedRecordings}
                    displayMode='inline'
                  />
                ) : (
                  <div className="empty-selection">
                    <p className="empty-title">Select a recording to view details</p>
                    <p className="empty-subtitle">Choose from the list on the left</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TiltDashboard;